import CryptoJS from "crypto-js";
import { getRuntimeConfig } from "lib/runtimeEnvClient";

/**
 * Get encryption seed from runtime environment
 * This function reads the seed at runtime, not at build time
 */
function getEncryptionSeed(): string {
  // Try NEXT_CONFIG_ENCRYPTATION_SEED first (for backward compatibility)
  // Then try ENCRYPTATION_SEED (the actual runtime variable)
  const seed =
    //getRuntimeEnv("NEXT_CONFIG_ENCRYPTATION_SEED") ||
    getRuntimeConfig("ENCRYPTATION_SEED");

  if (!seed) {
    throw new Error(
      "ENCRYPTATION_SEED not found. Please set either ENCRYPTATION_SEED or NEXT_CONFIG_ENCRYPTATION_SEED environment variable."
    );
  }

  return seed;
}

/**
 * Encrypt a value using the CryptoJS library.
 *
 *
 * @param value
 * @returns
 */
export function encrypt(value: string): string {
  const SEED = getEncryptionSeed();
  const encryptedBytes = CryptoJS.AES.encrypt(value, SEED);

  return encryptedBytes.toString();
}

/**
 * Decrypt a value using the CryptoJS library.
 *
 * @param value
 * @returns
 */
export function decrypt(value: string): string {
  const SEED = getEncryptionSeed();
  const decryptedBytes = CryptoJS.AES.decrypt(value, SEED);

  return decryptedBytes.toString(CryptoJS.enc.Utf8);
}
